






import { Vue, Component, Prop } from 'vue-property-decorator';
import debounce from '@/upload-entity-editor/utils/debounce';

@Component({})
export default class VirtualScrollbar extends Vue {
	@Prop() public target!: string;

	public mounted (): void {
		const scrollBarContainer = this.$refs['virtual-scroll'] as HTMLElement;
		const scrollBar = this.$refs['virtual-scroll-bar'] as HTMLElement;
		const scrollTarget = document.getElementById(this.target);

		if (scrollTarget == null) {
			// tslint:disable-next-line:no-console
			console.error(`Could not find a target element with the id "${scrollTarget}"`);
			return;
		}

		const synchronizeScroll = (source: HTMLElement, target: HTMLElement) => {
			target.scrollLeft = source.scrollLeft;
		};

		scrollBar.style.width = scrollTarget.scrollWidth.toString() + 'px';
		scrollBarContainer.addEventListener('scroll', () => {
			synchronizeScroll(scrollBarContainer, scrollTarget);
		});

		scrollTarget.addEventListener('scroll', debounce(() => {
			synchronizeScroll(scrollTarget, scrollBarContainer);
		}, 300));
	}
}
